// extracted by mini-css-extract-plugin
export default {"DataTableHeader":"Purchases_DataTableHeader__NVyuZ","DataTable":"Purchases_DataTable__78TON"};